import { render } from "./OrigenMultiselect.vue?vue&type=template&id=488427aa"
import script from "./OrigenMultiselect.vue?vue&type=script&lang=js"
export * from "./OrigenMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__